import React from "react";
import { useSearchParams } from "react-router-dom";
import {
  religionArray,
  durationOfContractArray,
  probationPeriodArray,
  bloodGroupArray,
  covidVaccineArray,
} from "./candidateListFunctions";

const filterStatusArray = [
  "SELECTED",
  "MEDICALLY UNFIT",
  "BACKED OUT",
  "UNDER PROCESS FOR VISA STAMP",
  "VISA STAMPED",
  "VISA CANCELLED REQUIREMENT FULFILLED",
  "TRAVELLING",
  "ARRIVED",
  "NOT TRAVELLED",
  "VISA CANCELLED",
];

export default function CandidateFilterPopup({
  filterView,
  setFilterView,
  FilterColumn,
  ResetFilter,
  filteringKeys,
  candidateData,
  statusFilter = false,
}) {
  const params = useSearchParams();
  const curentUrl = window.location.pathname;

  const selectedFields = [
    {
      id: 1,
      title: "Name",
      value: "name",
      default: true,
    },
    {
      id: 2,
      title: "Actual Profession",
      value: "job_position_name",
      width: "min-w-[12rem]",
      default: true,
      optionsArray: candidateData?.job_possition?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 3,
      title: "Nationality",
      value: "nationality_name",
      default: true,
      optionsArray: candidateData?.nationality?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 5,
      title: "Passport No.",
      value: "passport_number",
      default: true,
    },
    {
      id: 6,
      title: "VISA Profession",
      value: "visa_profession_name",
      optionsArray: [
        ...new Set(candidateData?.visa_profession?.map((data) => data?.name)),
      ],
      filter: true,
    },
    {
      id: 8,
      title: "Religion",
      value: "religion",
      optionsArray: religionArray,
      filter: true,
    },

    ...(statusFilter
      ? [
          {
            id: 9,
            title: "Status",
            value: "status",
            optionsArray: filterStatusArray,
            filter: true,
          },
        ]
      : []),

    {
      id: 11,
      title: "Sector",
      value: "sector_name",
      optionsArray: candidateData?.sector?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 15,
      title: "Selection Date",
      value: "selection_date",
      filter: true,
      filterType: "date",
    },
  ];

  const uniqueNames = [
    ...new Set(candidateData?.visa_profession?.map((data) => data?.name)),
  ];

  console.log(uniqueNames, "uniquire names");

  return (
    <>
      <div className="h-full z-10 min-w-full absolute left-0 top-0 bg-black/30"></div>
      <div
        className={`max-w-sm scroll-design  uppercase mt-5  gap-4 flex flex-col py-5 fixed -top-6 right-0 bg-white backdrop-opacity-10 min-h-screen h-screen z-50 shadow-lg transition-all ${
          !filterView
            ? "w-0 overflow-hidden px-0"
            : "w-[20rem] overflow-auto px-5"
        }`}
      >
        <h1 className="text-xl font-semibold uppercase">Filter</h1>
        <div className="h-[90vh] pr-3 overflow-y-auto">
          {selectedFields?.map((selectedData) => (
            <>
              {selectedData?.filter && (
                <div key={selectedData.id} className="flex flex-col gap-1 mb-3">
                  <p
                    className={`font-semibold w-full min-w-[10rem] ${selectedData.width}`}
                  >
                    {selectedData?.title}
                  </p>
                  {selectedData?.filter && (
                    <FilterColumn
                      filterBy={selectedData?.value}
                      optionsArray={selectedData?.optionsArray}
                      className={`w-full`}
                      filterType={selectedData?.filterType}
                      filteringKeys={filteringKeys}
                    />
                  )}
                </div>
              )}
            </>
          ))}
        </div>
        <div className="my-3 flex gap-3 justify-evenly">
          <button
            className="p-1 w-full px-4 rounded-md uppercase ring-1 ring-slate-300"
            onClick={() => setFilterView(false)}
          >
            Close
          </button>
          <button
            className="p-1 px-4 w-full rounded-md uppercase ring-1 ring-red bg-red text-white"
            onClick={() => {
              ResetFilter();
              setFilterView(false);
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
}
